var map = {
	"./WidgetLayout.vue": "3729",
	"./layouts/graph/GraphWidgetLayout.vue": "cf3d",
	"./layouts/graph/actions/FuturesBalanceActionGraphWidgetLayout.vue": "00d8",
	"./layouts/graph/actions/FuturesBalanceDeltaActionGraphWidgetLayout.vue": "1b4d",
	"./layouts/graph/actions/FuturesProfitActionGraphWidgetLayout.vue": "8fec",
	"./layouts/graph/actions/SpotBalanceActionGraphWidgetLayout.vue": "3242",
	"./layouts/number/NumberWidgetLayout.vue": "bac1",
	"./layouts/number/actions/FuturesBalanceActionNumberWidgetLayout.vue": "6853",
	"./layouts/number/actions/FuturesBalanceDeltaActionNumberWidgetLayout.vue": "9983",
	"./layouts/number/actions/FuturesProfitActionNumberWidgetLayout.vue": "0ae8",
	"./layouts/number/actions/SpotBalanceActionNumberWidgetLayout.vue": "610a",
	"./params/graph/GraphWidgetParams.vue": "e04d",
	"./params/graph/actions/FuturesBalanceActionGraphWidgetParams.vue": "14ca",
	"./params/graph/actions/FuturesBalanceDeltaActionGraphWidgetParams.vue": "2573",
	"./params/graph/actions/FuturesProfitActionGraphWidgetParams.vue": "6267",
	"./params/graph/actions/SpotBalanceActionGraphWidgetParams.vue": "78a4",
	"./params/number/NumberWidgetParams.vue": "b4c6",
	"./params/number/actions/FuturesBalanceActionNumberWidgetParams.vue": "3333",
	"./params/number/actions/FuturesBalanceDeltaActionNumberWidgetParams.vue": "adb7",
	"./params/number/actions/FuturesProfitActionNumberWidgetParams.vue": "cd6f",
	"./params/number/actions/SpotBalanceActionNumberWidgetParams.vue": "f023"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "81c1";